var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-layout-content",
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-card",
                    { attrs: { title: _vm.$t("lbl_download_tax_invoice") } },
                    [
                      _c(
                        "a-row",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-form",
                                _vm._b(
                                  {
                                    attrs: {
                                      layout: "vertical",
                                      form: _vm.form
                                    }
                                  },
                                  "a-form",
                                  _vm.formItemLayout,
                                  false
                                ),
                                [
                                  _c(
                                    "a-form-model-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          _vm.formRules.branch.label
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value:
                                                _vm.formRules.branch.decorator,
                                              expression:
                                                "formRules.branch.decorator"
                                            }
                                          ],
                                          attrs: {
                                            name: _vm.formRules.branch.name,
                                            placeholder: _vm.$t(
                                              _vm.formRules.branch.placeholder
                                            ),
                                            showSearch: true,
                                            "option-filter-prop": "children",
                                            "filter-option": _vm.filterOption,
                                            loading: _vm.loading.loadingBranch,
                                            allowClear: true
                                          },
                                          on: {
                                            search: function(value) {
                                              return _vm.getBranch(value)
                                            }
                                          }
                                        },
                                        _vm._l(_vm.dataBranch, function(
                                          data,
                                          index
                                        ) {
                                          return _c(
                                            "a-select-option",
                                            {
                                              key: index,
                                              attrs: { value: data.id }
                                            },
                                            [
                                              _c(
                                                "a-tooltip",
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "title" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(data.name) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(data.name) +
                                                      " "
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          _vm.formRules.taxMonth.label
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value:
                                                _vm.formRules.taxMonth
                                                  .decorator,
                                              expression:
                                                "formRules.taxMonth.decorator"
                                            }
                                          ],
                                          attrs: {
                                            name: _vm.formRules.taxMonth.name,
                                            placeholder: _vm.$t(
                                              _vm.formRules.taxMonth.placeholder
                                            ),
                                            showSearch: true,
                                            "option-filter-prop": "children",
                                            "filter-option": _vm.filterOption,
                                            loading:
                                              _vm.loading.loadingTaxMonth,
                                            allowClear: true
                                          },
                                          on: {
                                            search: function(value) {
                                              return _vm.getTaxMonth(value)
                                            }
                                          }
                                        },
                                        _vm._l(_vm.dataTaxMonth, function(
                                          data,
                                          index
                                        ) {
                                          return _c(
                                            "a-select-option",
                                            {
                                              key: index,
                                              attrs: { value: data.month }
                                            },
                                            [
                                              _c(
                                                "a-tooltip",
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "title" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(data.month) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(data.month) +
                                                      " "
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          _vm.formRules.customerName.label
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value:
                                                _vm.formRules.customerName
                                                  .decorator,
                                              expression:
                                                "formRules.customerName.decorator"
                                            }
                                          ],
                                          attrs: {
                                            name:
                                              _vm.formRules.customerName.name,
                                            placeholder: _vm.$t(
                                              _vm.formRules.customerName
                                                .placeholder
                                            ),
                                            showSearch: true,
                                            "option-filter-prop": "children",
                                            "filter-option": _vm.filterOption,
                                            loading:
                                              _vm.loading.loadingCustomerName,
                                            allowClear: true
                                          },
                                          on: {
                                            search: function(value) {
                                              return _vm.getCustomerName(value)
                                            }
                                          }
                                        },
                                        _vm._l(_vm.dataCustomer, function(
                                          data,
                                          index
                                        ) {
                                          return _c(
                                            "a-select-option",
                                            {
                                              key: index,
                                              attrs: { value: data.id }
                                            },
                                            [
                                              _c(
                                                "a-tooltip",
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "title" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            data.fullName.replace(
                                                              "null",
                                                              ""
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        data.fullName.replace(
                                                          "null",
                                                          ""
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          _vm.formRules.invoiceDate.label
                                        )
                                      }
                                    },
                                    [
                                      _c("a-range-picker", {
                                        directives: [
                                          {
                                            name: "decorator",
                                            rawName: "v-decorator",
                                            value:
                                              _vm.formRules.invoiceDate
                                                .decorator,
                                            expression:
                                              "formRules.invoiceDate.decorator"
                                          }
                                        ],
                                        attrs: {
                                          format: _vm.DEFAULT_DATE_FORMAT,
                                          placeholder: [
                                            _vm.$t("lbl_start_date"),
                                            _vm.$t("lbl_end_date")
                                          ]
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          _vm.formRules.invoiceARNumber.label
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value:
                                                _vm.formRules.invoiceARNumber
                                                  .decorator,
                                              expression:
                                                "formRules.invoiceARNumber.decorator"
                                            }
                                          ],
                                          attrs: {
                                            name:
                                              _vm.formRules.invoiceARNumber
                                                .name,
                                            placeholder: _vm.$t(
                                              _vm.formRules.invoiceARNumber
                                                .placeholder
                                            ),
                                            showSearch: true,
                                            "option-filter-prop": "children",
                                            "filter-option": _vm.filterOption,
                                            loading:
                                              _vm.loading
                                                .loadingInvoiceARNumber,
                                            allowClear: true
                                          },
                                          on: {
                                            search: function(value) {
                                              return _vm.getInvoiceARNumber(
                                                value
                                              )
                                            }
                                          }
                                        },
                                        _vm._l(
                                          _vm.dataInvoiceARNumber,
                                          function(data, index) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: index,
                                                attrs: {
                                                  value: data.documentNumber
                                                }
                                              },
                                              [
                                                _c(
                                                  "a-tooltip",
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "title" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              data.documentNumber
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          data.documentNumber
                                                        ) +
                                                        " "
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    [
                                      _c(
                                        "a-space",
                                        [
                                          _c(
                                            "a-button",
                                            {
                                              attrs: { type: "danger" },
                                              on: { click: _vm.handleReset }
                                            },
                                            [_vm._v(" Reset ")]
                                          ),
                                          _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                loading:
                                                  _vm.loading.loadingClose
                                              },
                                              on: {
                                                click: _vm.handleDownloadCSV
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.download-text",
                                                      {
                                                        text: _vm.$t("lbl_csv")
                                                      }
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                loading:
                                                  _vm.loading.loadingClose
                                              },
                                              on: {
                                                click: _vm.handleDownloadXML
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.download-text",
                                                      {
                                                        text: _vm.$t("lbl_xml")
                                                      }
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }